import React, { PureComponent } from 'react'
import { Input, Select } from '@driftt/tide-core-legacy'

import { forOwn, isObject } from 'lodash'
import { clone } from 'ramda'

const DEFAULT_VALUE = 100

const mapObjectToOptions = (obj) => { 
  const options = []

  forOwn(obj, (value, key) => {
    options.push({ label: value, value: key })
  })

  return options
}

const OPERATOR_MAP = {
  greaterThan: "is greater than",
  lessThan: "is less than",
  isBetween: "is between"
}

class NumericalValuesFilter extends PureComponent {
  constructor(props) {
    super(props)

    this.state ={
      selectedOperator: props.activeFilter.operator || Object.keys(OPERATOR_MAP)[0],
      selectedValue: props.activeFilter.value,
      isGroupValue: !!props.activeFilter && isObject(props.activeFilter.value)
    }
  }

  onConditionUpdated = () => {
    const { activeFilter, onUpdateCondition } = this.props 
    const { selectedOperator, selectedValue } = this.state

    const cloneFilter = clone(activeFilter)
    cloneFilter.operator = selectedOperator,
    cloneFilter.value = selectedValue

    onUpdateCondition(cloneFilter)
  }

  onOperatorChange = (option) => {
    if (option === null) {
      return
    }

    const isGroup = option.value === 'isBetween'

    this.setState({ 
      selectedOperator: option.value, 
      isGroupValue: isGroup,
      selectedValue: isGroup ? {} : DEFAULT_VALUE
    }, this.onConditionUpdated)
  }

  onSingleValueChanged = (evt) => {
    const value = evt.target.value
    this.setState({ selectedValue: value }, this.onConditionUpdated)
  }

  onMinValueChanged = (evt) => {
    const { selectedValue } = this.state
    const value = evt.target.value

    if (isObject(selectedValue)) {
      this.setState({ selectedValue: Object.assign({}, selectedValue, { min: value })}, this.onConditionUpdated)
    } else {
      this.setState({ selectedValue: { min: value }}, this.onConditionUpdated)
    }
  }

  onMaxValueChanged = (evt) => {
    const { selectedValue } = this.state
    const value = evt.target.value

    if (isObject(selectedValue)) {
      this.setState({ selectedValue: Object.assign({}, selectedValue, { max: value })}, this.onConditionUpdated)
    } else {
      this.setState({ selectedValue: { max: value }}, this.onConditionUpdated)
    }
  }

  renderOperatorOptions = () => {
    return (
      <Select className="operator-select" clearable={false} options={mapObjectToOptions(OPERATOR_MAP)} value={this.state.selectedOperator} onChange={this.onOperatorChange}/>
    )
  }

  renderOperatorInputs = () => {
    const { selectedOperator, selectedValue, isGroupValue } = this.state

    if (!isGroupValue) {
      return (
        <div className="numerical-values-singular-input">
          <Input value={selectedValue} onChange={this.onSingleValueChanged}/>
        </div>
      )
    } else {
      const value = selectedValue || {}

      return (
        <div className="between-container">
          <Input value={value.min} onChange={this.onMinValueChanged}/>
          <span className="between-container-text">And</span>
          <Input value={value.max} onChange={this.onMaxValueChanged}/>
        </div>
      )
    }
  }

  render() {
    return (
      <div className="rules-choice-content drift-form numerical-filter">
        {this.renderOperatorOptions()}
        {this.renderOperatorInputs()}
      </div>
    )
  }

}

export default NumericalValuesFilter


// WEBPACK FOOTER //
// ./src/scripts/components/settings/Rules/components/FilterEditor/FirmographicFilter/NumericalValuesFilter.js